import {createAsyncThunk} from "@reduxjs/toolkit"
import {DOMAIN_API} from "../../utils/api"
import {ThunkProps} from "../store"
import {ApiResponseType} from "../../types/api"
import {getAdminRequestHeaders} from "../../utils/apiHeaders"

interface AuthProps {
    username: string
    password: string
}

interface AuthResponseType {
    access_token: string
    ttl: number
}

export const authByLoginAndPasswordAction = createAsyncThunk<ApiResponseType<AuthResponseType>, AuthProps, ThunkProps>(
    "auth/login-password",
    async ({username, password}) => {
        const response = await fetch(DOMAIN_API + `/v1/users/login`, {
            method: "POST",
            headers: {
                ...getAdminRequestHeaders(),
                "Content-Type": "application/json"
            },
            body: JSON.stringify({username, password})
        })
        if (response.ok) return await response.json()
        throw await response.json()
    }
)
